import React from 'react';
import { NavLink } from 'react-router-dom';
import FormInput from '../../components/form/FormInput';
import FormButton from '../../components/form/FormButton';
import clsx from 'clsx';
const RegisterComponent = ({tr}) => {
    return (
        <div className={clsx("w-full max-w-md mx-auto bg-white rounded-lg shadow-md dark:border md:mt-0 xl:p-0",
            "bg-gradient-to-br from-gray-50 to-gray-100 dark:from-gray-800 dark:to-gray-900",
            "rounded-xl shadow-md hover:shadow-xl",
            "transition-all duration-300 ease-in-out overflow-hidden",
            "border-2 border-gray-200 dark:border-gray-700"
        )}>
            <div className="p-6 space-y-4 md:space-y-6 sm:p-8">
                <h1 className="text-xl font-bold leading-tight tracking-tight text-gray-500 md:text-2xl">{tr('description')}</h1>
                <div className="space-y-4 md:space-y-6" action="#">
                    <FormInput id="email" type="email" label={tr('email')} placeholder={tr('emailPlaceholder')} />
                    <FormInput id="password" type="password" label={tr('password')} placeholder={tr('passwordPlaceholder')} />
                    <FormInput id="confirmPassword" type="password" label={tr('confirmPassword')} placeholder={tr('confirmPasswordPlaceholder')} />
                    <FormButton>{tr('signUp')}</FormButton>
                    <p className="text-sm font-light dark:text-gray-400 text-gray-500">
                        {tr('haveAccount')} {" "}
                        <NavLink to="/login" className="font-medium text-gray-500 hover:text-[#41A6D7]">
                            {tr('signIn')}
                        </NavLink>
                    </p>
                </div>
            </div>
        </div>
    );
};

export default RegisterComponent;
